const XIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path
        d="M4.819 4.348c-.437.162-.632.628-.432 1.03.029.058 1.067 1.122 2.308 2.364L8.95 10l-2.255 2.258C5.454 13.5 4.413 14.569 4.38 14.633c-.13.252-.054.662.158.855.218.197.588.257.829.132.064-.033 1.133-1.074 2.375-2.315L10 11.05l2.258 2.255c1.242 1.241 2.311 2.282 2.375 2.315.252.13.662.054.855-.158.197-.218.257-.588.132-.829-.033-.064-1.074-1.133-2.315-2.375L11.05 10l2.255-2.258c1.241-1.242 2.282-2.311 2.315-2.375.125-.241.065-.611-.132-.829-.193-.212-.603-.288-.855-.158-.064.033-1.133 1.074-2.375 2.315L10 8.95 7.742 6.695C6.5 5.454 5.434 4.415 5.373 4.385a.778.778 0 0 0-.554-.037"
        fillRule="evenodd"
      />
    </svg>
  );
};

export { XIcon };
